import React from "react";
import { Form, Input,Radio,Row,Col } from 'antd';
import NHFormItem from '../../common/NHFormItem';
import { hasAuth} from "../../../utils/NHCore";
const { TextArea } = Input;
const RadioGroup = Radio.Group;
class AuditForm extends React.Component {
    static defaultProps = {
        isInit:false,
        studentCount:0,
    }
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentWillMount(){
    }

    componentDidMount() {
    }


    render() {
        const {form} = this.props;
        const {getFieldDecorator} = form;
        //Alert提示布局
        const formItemLayout = {
            wrapperCol: {
                xs: { span: 24, offset: 0 },
                sm: { span: 12, offset: 6 },
                md: { span: 14, offset: 7 }
            }
        };
        const formItemLayout2 = {
            labelCol:{ span:18},
            wrapperCol:{span:5}
        };
        let formItemLayout1 = {
            labelCol: { span: 6 },
            wrapperCol: { span: 16 },
        };
        return (
            <div style={{width:'100%'}}>
                <Form layout="inline" style={{width:'100%',marginBottom:'14px'}}>
                    <div>
                        <NHFormItem formItemLayout={formItemLayout1} id={'shzt'} label={"审核状态"} form={form} required={true}>
                            <RadioGroup>
                                <Radio value={'1'}>通过</Radio>
                                <Radio value={'-1'}>不通过</Radio>
                                <Radio value={'9'}>驳回</Radio>
                            </RadioGroup>
                        </NHFormItem>
                    </div>
                    <div >
                    <NHFormItem formItemLayout={formItemLayout1} id={'shyj'} label={"审核意见"} form={form}>
                        <TextArea placeholder={'审核意见'} autosize={{minRows:2,maxRows:5}} />
                    </NHFormItem>
                    </div>
                </Form>
                <style jsx="true" global='true'>
                    {`
                        .ant-form-item{
                            width:100% !important;
                        }
                    `}
                </style>
            </div>
        );
    }
}

const auditForm = Form.create()(AuditForm);

export default auditForm;


// WEBPACK FOOTER //
// ./components/swbl/sfzs/AuditModal.js